var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCornerRadius24 = function SvgIconCornerRadius24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.425 6.305a2.15 2.15 0 0 0-2.15 2.15v7a2.15 2.15 0 0 0 2.15 2.15h7a2.15 2.15 0 0 0 2.15-2.15v-7a2.15 2.15 0 0 0-2.15-2.15h-7Zm-3.85 2.15a3.85 3.85 0 0 1 3.85-3.85h7a3.85 3.85 0 0 1 3.85 3.85v7a3.85 3.85 0 0 1-3.85 3.85h-7a3.85 3.85 0 0 1-3.85-3.85v-7Z",
    fill: "current"
  })));
};
export default SvgIconCornerRadius24;